<template>
  <div>
    <div id="cont">
      <div class="thumb-val-cont">
        <svg
          class="thumb-val-svg"
          viewBox="0 0 10 10"
          :style="{ marginLeft: sliderLowerLabelMargin }"
        >
          <text x="5" y="7" font-size="7" text-anchor="middle">
            {{ lowerValue }}
          </text>
        </svg>
      </div>
      <div class="thumb-val-cont">
        <svg
          class="thumb-val-svg"
          viewBox="0 0 10 10"
          :style="{ marginLeft: sliderUpperLabelMargin }"
        >
          <text x="5" y="7" font-size="7" text-anchor="middle">
            {{ upperValue }}
          </text>
        </svg>
      </div>
      <div id="min-label">
        <svg
          viewBox="0 0 12 10"
          preserveAspectRatio="xMaxYMid slice"
          class="svg-label"
        >
          <text
            x="6.5"
            y="5"
            font-size="3.5"
            text-anchor="middle"
            dominant-baseline="middle"
          >
            {{ min }}
          </text>
        </svg>
      </div>
      <div class="visual-track-gray"></div>
      <div
        class="visual-track-green"
        :style="{ marginLeft: fillLeftMargin, marginRight: fillRightMargin }"
      ></div>
      <input
        ref="lowerSlider"
        type="range"
        :min="min"
        :max="max"
        v-model="sliderLowerValue"
        class="slider"
      />
      <input
        ref="upperSlider"
        type="range"
        :min="min"
        :max="max"
        v-model="sliderUpperValue"
        class="slider"
      />
      <div id="max-label">
        <svg
          viewBox="0 0 10 10"
          preserveAspectRatio="xMinYMid meet"
          class="svg-label"
        >
          <text
            x="1"
            y="5"
            font-size="6"
            text-anchor="start"
            dominant-baseline="middle"
          >
            {{ max }}
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TargetRangeSlider',
  props: {
    min: { default: 55, type: Number },
    max: { default: 70, type: Number },
    gap: { default: 10, type: Number },
    lowerValue: { default: 65, type: Number },
    upperValue: { default: 85, type: Number },
    allowHypo: { default: false, type: Boolean },
    hypoThreshold: { default: 55, type: Number }
  },
  computed: {
    sliderLowerValue: {
      get: function() {
        return parseInt(this.lowerValue)
      },
      set: function(val) {
        val = parseInt(val)
        let newLower = val
        let newUpper = this.upperValue
        // Limit slider, accounting for gap and allow hypo state
        if (!this.allowHypo && val < this.hypoThreshold) {
          this.$refs['lowerSlider'].value = this.hypoThreshold
          newLower = this.hypoThreshold
          this.$emit('range-changed', newLower, newUpper)
          return
        }
        if (val > this.max - this.gap) {
          this.$refs['lowerSlider'].value = this.max - this.gap
          newLower = this.max - this.gap
          newUpper = this.max
          this.$emit('range-changed', newLower, newUpper)
          return
        }
        if (val > this.upperValue - this.gap) {
          newUpper = val + this.gap
        }
        this.$emit('range-changed', newLower, newUpper)
      }
    },
    sliderUpperValue: {
      get: function() {
        return parseInt(this.upperValue)
      },
      set: function(val) {
        val = parseInt(val)
        let newLower = this.lowerValue
        let newUpper = val
        // Limit slider, accounting for gap and allow hypo state
        if (!this.allowHypo && val < this.hypoThreshold + this.gap) {
          this.$refs['upperSlider'].value = this.hypoThreshold + this.gap
          newUpper = this.hypoThreshold + this.gap
          newLower = this.hypoThreshold
          this.$emit('range-changed', newLower, newUpper)
          return
        }
        if (val < this.min + this.gap) {
          this.$refs['upperSlider'].value = this.upperValue
          newUpper = this.min + this.gap
          newLower = this.min
          this.$emit('range-changed', newLower, newUpper)
          return
        }
        if (val < this.lowerValue + this.gap) {
          newLower = val - this.gap
        }
        this.$emit('range-changed', newLower, newUpper)
      }
    },
    sliderLowerLabelMargin() {
      return ((this.lowerValue - this.min) / (this.max - this.min)) * 95 + '%'
    },
    sliderUpperLabelMargin() {
      return ((this.upperValue - this.min) / (this.max - this.min)) * 95 + '%'
    },
    fillLeftMargin() {
      return (
        ((this.lowerValue - this.min) / (this.max - this.min)) * 95 + 2 + '%'
      )
    },
    fillRightMargin() {
      return (
        ((this.max - this.upperValue) / (this.max - this.min)) * 95 + 2 + '%'
      )
    }
  }
}
</script>

<style scoped>
text {
  fill: black;
}
#cont {
  box-sizing: border-box;
  display: grid;
  align-items: center;
  grid-template-columns: 10% 85% 5%;
  grid-template-rows: 50% 50%;
  row-gap: 30%;
  width: 100%;
  height: 100%;
}
.thumb-val-cont {
  grid-row: 1;
  grid-column: 2;
  height: 100%;
  width: 100%;
  background-color: transparent;
  overflow: visible;
}
.thumb-val-svg {
  overflow: visible;
  height: 100%;
}
#min-label {
  grid-column: 1;
  grid-row: 2;
  height: 100%;
  width: 100%;
}
#max-label {
  grid-column: 3;
  grid-row: 2;
  height: 100%;
  width: 100%;
}
.svg-label {
  height: 100%;
  width: 100%;
}
.slider {
  grid-column: 2;
  grid-row: 2;
  width: 100%;
  pointer-events: none;
}
.visual-track-gray {
  grid-column: 2;
  grid-row: 2;
  height: 30%;
  pointer-events: none;
  background-color: #6d7278;
  border: solid 1px black;
  border-radius: 999px;
}
.visual-track-green {
  grid-column: 2;
  grid-row: 2;
  height: 30%;
  pointer-events: none;
  background-color: #00524c;
  border-radius: 999px;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-thumb {
  width: 1.7%;
  height: 2em;
  border-radius: 999px;
  border-width: 0;
  background: #00524c;
  cursor: pointer;
  -webkit-appearance: none;
  pointer-events: auto;
}
[type='range'] {
  height: 1.5em;
  background: transparent;
}
[type='range'],
[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none;
}
[type='range']::-webkit-slider-runnable-track {
  box-sizing: border-box;
  border: none;
  width: 96%;
  height: 0.75em;
  border-radius: 999px;
  background: transparent;
}
[type='range']::-moz-range-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 96%;
  height: 0.25em;
  border-radius: 999px;
  background: transparent;
}
[type='range']::-ms-track {
  box-sizing: border-box;
  border: 1px solid #000000;
  width: 100%;
  height: 0.25em;
  border-radius: 999px;
  background: transparent;
}
[type='range']::-webkit-slider-thumb {
  margin-top: -1.6em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 3.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-moz-range-thumb {
  margin-top: -1.6em;
  box-sizing: border-box;
  border: none;
  width: 1.5em;
  height: 3.2em;
  border-radius: 999px;
  background: #00524c;
}
[type='range']::-ms-thumb {
  margin-top: 0;
  box-sizing: border-box;
  border: none;
  width: 0.5em;
  height: 1.2em;
  border-radius: 999px;
  background: #00524c;
}
</style>
